import { useEffect, useState } from 'react';
import { Button, Card } from '#root/components/ui';
import { Skeleton } from '#root/components/ui/primitives';
import { SparksIcon } from '#root/icons';
import { cn } from '#root/lib/utils';
import { travelerService } from '#root/services';
import type { MatchSummaryDTO } from '#root/models/PrepaidMatchDTO';
import styles from './match.module.scss';

/** Fotos que caben en la fila; el resto se resume en "+N" */
const MAX_IMAGES = 4;

interface MatchPromoCardProps {
  /** Pasa a la pestaña Match */
  onOpen: () => void;
  /** Espaciado que pone quien la usa: si no hay card, tampoco queda el hueco */
  className?: string;
}

/**
 * Card de la pestaña "Todos" que lleva a Match. Skeleton mientras carga; si falla (también un
 * BE sin `/match/summary`) o no hay pedidos disponibles, no se muestra nada.
 */
const MatchPromoCard = ({ onOpen, className }: MatchPromoCardProps) => {
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState<MatchSummaryDTO | null>(null);

  useEffect(() => {
    let active = true;
    travelerService.matchSummary().then((res) => {
      if (!active) return;
      if (!res.error) setSummary(res.data as MatchSummaryDTO);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);

  if (loading) return <Skeleton className={cn(styles.promoSkeleton, className)} />;
  if (!summary || !(summary.available_orders > 0)) return null;

  const count = summary.available_orders;
  const plural = count > 1;
  const images = summary.images.slice(0, MAX_IMAGES);
  const rest = count - images.length;

  // El botón no tiene `onClick`: su clic sube a la card (y con el teclado, Enter también)
  return (
    <Card className={cn(styles.promo, className)} onClick={onOpen}>
      <div className={styles.promoBody}>
        <h3 className={styles.promoTitle}>
          <SparksIcon fontSize="small" />
          {count} {plural ? 'Pedidos Match esperando' : 'Pedido Match esperando'}
        </h3>
        <div className={styles.promoMedia}>
          {images.length > 0 && (
            <div className={styles.promoImages}>
              {images.map((src, index) => (
                <img key={index} className={styles.promoImage} src={src} alt="" loading="lazy" />
              ))}
              {rest > 0 && <span className={styles.promoRest}>+{rest}</span>}
            </div>
          )}
          <div className={styles.promoTextAndAction}>
            <p className={styles.promoText}>
              {plural
                ? 'Pedidos pagados esperando por viajeros'
                : 'Pedido pagado esperando por viajeros'}
            </p>
            <Button className={styles.promoAction} variant="match" size="sm">
              Ver Pedidos Match
            </Button>
          </div>
        </div>
      </div>


    </Card>
  );
};

export default MatchPromoCard;
